// src/utils/recurringUtils.js

const pad2 = (n) => String(n).padStart(2, "0");
export const toYMD = (d) =>
    `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const parseYMDLocal = (ymd) => {
    const [y, m, d] = String(ymd || "").split("-").map(Number);
    if (!y) return null;
    return new Date(y, (m || 1) - 1, d || 1);
};

const nthDowOfMonth = (year, monthIndex, dow, nth) => {
    if (nth === -1) {
        const lastDay = new Date(year, monthIndex + 1, 0);
        const diff = (lastDay.getDay() - dow + 7) % 7;
        return new Date(year, monthIndex, lastDay.getDate() - diff);
    }
    const first = new Date(year, monthIndex, 1);
    const diff = (dow - first.getDay() + 7) % 7;
    const day = 1 + diff + (nth - 1) * 7;
    const candidate = new Date(year, monthIndex, day);
    return candidate.getMonth() === monthIndex ? candidate : null;
};

/**
 * ✅ Ambil kitabId dari pelbagai bentuk data (baru + legacy)
 * Pastikan recurring occurrence ada field kitabId supaya filter "ikut kitab" jalan.
 */
export const extractKitabId = (r) => {
    if (r?.kitabId) return String(r.kitabId);
    if (r?.kitab?.id) return String(r.kitab.id);
    if (r?.kitabRef?.id) return String(r.kitabRef.id);
    if (r?.kitab_id) return String(r.kitab_id);
    if (r?.kitabDocId) return String(r.kitabDocId);
    return "";
};



export const expandRecurringRules = (rules = [], masjidId, nowMs, windowDays = 90) => {
    const out = [];
    const now = new Date(nowMs);
    const windowEnd = new Date(nowMs + windowDays * 86400000);

    for (const r of rules) {
        const repeat = r?.repeat;
        const startYMD = r?.repeatStart;
        const endYMD = r?.repeatEnd;
        const time = r?.time || "00:00";

        const startDate = parseYMDLocal(startYMD);
        const endDate = parseYMDLocal(endYMD);
        if (!startDate || !endDate) continue;
        endDate.setHours(23, 59, 59, 999);

        // ✅ fallback utk data lama yang tak simpan repeatDow/repeatNth
        const base = parseYMDLocal(startYMD);
        const weekOfMonth = (d) => Math.floor((d.getDate() - 1) / 7) + 1;
        const isLastSameDowInMonth = (d) => {
            const x = new Date(d);
            x.setDate(x.getDate() + 7);
            return x.getMonth() !== d.getMonth();
        };

        const derivedDow = base ? base.getDay() : 0;
        const derivedNth = base ? (isLastSameDowInMonth(base) ? -1 : weekOfMonth(base)) : 1;

        const repeatDow =
            r?.repeatDow !== undefined && r?.repeatDow !== null ? Number(r.repeatDow) : derivedDow;
        const repeatNth =
            r?.repeatNth !== undefined && r?.repeatNth !== null ? Number(r.repeatNth) : derivedNth;

        const from = new Date(Math.max(startDate.getTime(), now.getTime()));
        const to = new Date(Math.min(endDate.getTime(), windowEnd.getTime()));
        if (from > to) continue;

        // ✅ ambil kitabId sekali sahaja
        const kitabId = extractKitabId(r);

        if (repeat === "weekly") {
            const dow = repeatDow;
            if (Number.isNaN(dow)) continue;

            const cur = new Date(from);
            cur.setHours(0, 0, 0, 0);
            const delta = (dow - cur.getDay() + 7) % 7;
            cur.setDate(cur.getDate() + delta);

            while (cur <= to) {
                const dt = new Date(cur);
                const [hh, mm] = String(time).split(":").map(Number);
                dt.setHours(hh || 0, mm || 0, 0, 0);

                if (dt.getTime() > nowMs) {
                    out.push({
                        ...r,
                        masjidId,
                        kitabId, // ✅ penting untuk filter ikut kitab
                        eventId: `${r.seriesId || r.seriesKey}-${toYMD(dt)}-${time}`,
                        start: dt,
                    });
                }
                cur.setDate(cur.getDate() + 7);
            }
        }

        if (repeat === "monthly") {
            const dow = repeatDow;
            const nth = repeatNth;
            if (Number.isNaN(dow) || Number.isNaN(nth)) continue;

            let y = from.getFullYear();
            let m = from.getMonth();

            const endY = to.getFullYear();
            const endM = to.getMonth();

            while (y < endY || (y === endY && m <= endM)) {
                const day = nthDowOfMonth(y, m, dow, nth);
                if (day) {
                    const dt = new Date(day);
                    const [hh, mm] = String(time).split(":").map(Number);
                    dt.setHours(hh || 0, mm || 0, 0, 0);

                    if (dt >= from && dt <= to && dt.getTime() > nowMs) {
                        out.push({
                            ...r,
                            masjidId,
                            kitabId, // ✅ penting untuk filter ikut kitab
                            eventId: `${r.seriesId || r.seriesKey}-${toYMD(dt)}-${time}`,
                            start: dt,
                        });
                    }
                }
                m += 1;
                if (m > 11) {
                    m = 0;
                    y += 1;
                }
            }
        }
    }

    return out;
};
